<template>
  <!-- 预览配载 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button class="glo_btnItems glo_bgcMainColor" @click="clickStowage">返回</el-button>
        <el-button class="glo_btnItems" @click="clickAffirm('SAVE', '确认配载')">确认配载</el-button>
        <el-button class="glo_btnItems" @click="clickAffirm('DISPATCH', '确认配载并调度')">确认配载并调度</el-button>
      </div>
    </div>
    <div class="infoDiv" v-for="(itemP, indexP) in listPreviewStowage" :key="indexP">
      <div class="h3title">发车批次号：{{ itemP.dispatchNumber }}</div>
      <div class="formbox">
        <el-form class="glo_formBox" ref="dialogFormREF" label-width="120px">
          <el-form-item class required label="车辆分类:">
            <el-select filterable clearable v-model="itemP.carCategoryConfDictId" placeholder="请选择" @change="changecarCategoryConfDictId($event, indexP)">
              <el-option v-for="(item, index) in car_categoryList" :key="index" :label="item.key" :value="item.confDictId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class required label="是否牵引车:">
            <el-select filterable clearable v-model="itemP.isTractor" placeholder="请选择">
              <el-option v-for="(item, index) in isTractorList" :key="index" :label="item.name" :value="item.val"></el-option>
            </el-select>
            <!-- <el-select clearable v-model="itemP.isTractor" placeholder="请选择">
              <el-option v-for="(item, index) in isTractorList" :key="index" :label="item.name" :value="item.val"></el-option>
            </el-select>-->
          </el-form-item>
          <el-form-item class required label="车牌号码:">
            <el-select filterable clearable allow-create remote v-model="itemP.carNumber" placeholder="请选择">
              <el-option v-for="(item, index) in itemP.carNumberList1" :key="index" :label="item.carNumber" :value="item.carNumber"></el-option>
            </el-select>
          </el-form-item>
          <!-- 是否牵引车,是,挂车号必填 -->
          <!-- 是否牵引车,否,挂车号不是必填 -->
          <el-form-item class label="挂车号码:" :required="itemP.isTractor == 1 ? true : false">
            <el-select filterable clearable allow-create remote :remote-method="(e) => getcarNumberRmethod(e, indexP)" v-model="itemP.trailerNumber" placeholder="请选择">
              <el-option v-for="(item, index) in itemP.carNumberList2" :key="index" :label="item.carNumber" :value="item.carNumber"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class required label="司机一:">
            <el-select filterable clearable v-model="itemP.driverOneId" placeholder="请选择" @change="(e) => changeDriver(e, indexP)">
              <el-option v-for="(item, index) in driverList" :key="index" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class label="押运员一:">
            <el-select v-model="itemP.supercargoOneId" placeholder="请选择" filterable clearable @change="(e) => changeDriver3(e, indexP)">
              <el-option v-for="(item, index) in driverList" :key="index" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class label="司机二:">
            <el-select filterable clearable v-model="itemP.driverTwoId" placeholder="请选择" @change="(e) => changeDriver2(e, indexP)">
              <el-option v-for="(item, index) in driverList" :key="index" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class label="押运员二:">
            <el-select v-model="itemP.supercargoTwoId" placeholder="请选择" filterable clearable @change="(e) => changeDriver4(e, indexP)">
              <el-option v-for="(item, index) in driverList" :key="index" :label="item.name" :value="item.documentId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class required label="发车合同号:">
            <el-input v-model="itemP.dispatchContractNumber" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="dialogTims" required label="预计发车日期:">
            <el-date-picker class="input" :key="indexP" value-format="yyyy-MM-dd" v-model="itemP.planDepartureTime" type="date" placeholder="选择日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="textArea" style="width: 100%" label="备注:">
            <el-input type="textarea" rows="2" v-model="itemP.remarks"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="glo_btnList">
        <div class="glo_btnList_left">
          <el-button class="glo_btnItems" @click="clickHase(indexP)">
            {{
            itemP.isHase ? "收起" : "展开"
            }}
          </el-button>
          <span class="tipsclass" v-if="itemP.isHasClash == 1">！含有冲突品类商品</span>
        </div>
      </div>
      <!-- 表格 -->
      <div class="glo_Table" v-if="itemP.isHase">
        <el-table row-key="indexset" header-align="center" :data="itemP.childs" border stripe :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <template v-for="(item, index) in goodsTableHeard">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            ></el-table-column>
            <el-table-column
              v-else-if="item.field == 'unloadAreaName' && item.isShow"
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
            >
              <template slot-scope="scope">
                <span>
                  {{ scope.row.unloadProvinceName
                  }}{{ scope.row.unloadCityName
                  }}{{ scope.row.unloadAreaName }}
                </span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  inject: ["reload"],
  components: {},
  data() {
    return {
      goodsTableHeard: [
        {
          name: "序号",
          field: "indexset",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "到货区域",
          field: "unloadAreaName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "卸货地址",
          field: "taskEndAllAddress",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "任务编号",
          field: "number",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "运单号",
          field: "waybillNumber",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类",
          field: "itemCategoryName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "包装",
          field: "packageName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCout",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "136",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/m³",
          field: "volume",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "specs",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "开单备注",
          field: "remarks",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      car_categoryList: [], //车辆分类
      isTractorList: [
        { val: 0, name: "否" },
        { val: 1, name: "是" },
      ],
      // car_type_list: [], //车型
      // carTypeConfDictId: "",
      driverList: [], //司机列表
      selectList: [],
      listPreviewStowage: [],

      queryData: {
        carrierId: "",
        customerName: "",
        endCreateTime: "",
        endTaskCreateTime: "",
        fieldName: "",
        fieldVal: "",
        startCreateTime: "",
        startTaskCreateTime: "",
        taskEndAllAddress: "",
        taskStartAllAddress: "",
        transportPlan: "",
        waybillNumber: "",
      }, //  表单查询数据
      timeType: "0", //  时间类型
      startTime_a: "",
      endTime_a: "",
      returnList: [],
    };
  },
  created() {},
  activated() {
    let {
      selectList,
      returnList,
      queryData,
      timeType,
      startTime_a,
      endTime_a,
    } = this.$route.query;
    if (selectList && selectList.length) {
      this.selectList = JSON.parse(decodeURIComponent(selectList)) || [];
      this.checkTaskHasClashItemApi();
    }
    if (returnList) {
      this.returnList = JSON.parse(decodeURIComponent(returnList)) || [];
      if (queryData) {
        this.queryData = JSON.parse(decodeURIComponent(queryData));
      }
      this.timeType = timeType;
      this.startTime_a = startTime_a;
      this.endTime_a = endTime_a;
    }
  },
  mounted() {
    this.getConfDictValDownLists("car_category");
    this.getObjectUserDownList("driver");
  },
  watch: {},
  methods: {
    clickHase(index) {
      // let arrs = JSON.parse(JSON.stringify(this.listPreviewStowage));
      let arrs = _.cloneDeep(this.listPreviewStowage);
      arrs[index].isHase = !arrs[index].isHase;
      this.listPreviewStowage = arrs;
    },
    // 根据字典类型获取字典值下拉列表 getConfDictValDownLists(car_category)
    getConfDictValDownLists(val) {
      this.$COMAPI.getConfDictValDownList(val).then((res) => {
        //车辆分类
        if (val == "car_category") {
          this.car_categoryList = res || [];
        }
      });
    },
    // 获取车辆下拉列表(拿车牌号码)
    changecarCategoryConfDictId(e, index) {
      console.log("e", e);
      let arrs = _.cloneDeep(this.listPreviewStowage);
      arrs[index].carNumber = "";
      if (e) {
        this.$API
          .CarDownList({
            pageStart: 1,
            pageTotal: 200,
            carNumber: "",
            carCategoryConfDictId: e, //车辆分类id
          })
          .then((res) => {
            let carNumberList1 = res.data.result.data || [];
            arrs[index].carNumberList1 = carNumberList1;
            this.listPreviewStowage = arrs;
          });
      }
    },
    // 获取车辆下拉列表(拿挂车号码)
    getcarNumberRmethod(e, index) {
      console.log("e", e, index);
      this.$API
        .CarArchiveList({
          pageStart: 1,
          pageTotal: 200,
          carNumber: e || "",
        })
        .then((res) => {
          let arrs = _.cloneDeep(this.listPreviewStowage);
          let carNumberList2 = res.data.result.data || [];
          arrs[index].carNumberList2 = carNumberList2;
          this.listPreviewStowage = arrs;
        });
    },
    // 根据对象类型获取对象的下拉列表 getObjectUserDownList('driver')
    getObjectUserDownList(key) {
      this.$COMAPI.getObjectUserDownList(key).then((res) => {
        if (key == "driver") {
          this.driverList = res || [];
        }
      }); //获取网点列表
    },
    // 选择司机
    changeDriver(e, index) {
      let arrs = _.cloneDeep(this.listPreviewStowage);
      if (e) {
        this.driverList.forEach((item) => {
          if (item.documentId == e) {
            arrs[index].driverOneName = item.name;
          }
        });
      } else {
        arrs[index].driverOneName = "";
      }
      this.listPreviewStowage = arrs;
    },
    // 选择司机2
    changeDriver2(e, index) {
      let arrs = _.cloneDeep(this.listPreviewStowage);
      if (e) {
        this.driverList.forEach((item) => {
          if (item.documentId == e) {
            arrs[index].driverTwoName = item.name;
          }
        });
      } else {
        arrs[index].driverTwoName = "";
      }
      this.listPreviewStowage = arrs;
    },
    // 选择押运1
    changeDriver3(e, index) {
      let arrs = _.cloneDeep(this.listPreviewStowage);
      if (e) {
        this.driverList.forEach((item) => {
          if (item.documentId == e) {
            arrs[index].supercargoOneName = item.name;
          }
        });
      } else {
        arrs[index].supercargoOneName = "";
      }
      this.listPreviewStowage = arrs;
    },
    // 选择押运2
    changeDriver4(e, index) {
      let arrs = _.cloneDeep(this.listPreviewStowage);
      if (e) {
        this.driverList.forEach((item) => {
          if (item.documentId == e) {
            arrs[index].supercargoTwoName = item.name;
          }
        });
      } else {
        arrs[index].supercargoTwoName = "";
      }
      this.listPreviewStowage = arrs;
    },
    clickStowage() {
      //  返回
      // this.$router.go(-1);
      this.$router.push({
        path: "/DispatchCar/TasksLoaded/NewBuiltStowage",
        query: {
          selectTableData: this.returnList.length
            ? encodeURIComponent(JSON.stringify(this.returnList))
            : "",
          queryData: encodeURIComponent(JSON.stringify(this.queryData)),
          timeType: this.timeType,
          startTime_a: this.startTime_a,
          endTime_a: this.endTime_a,
        },
      });
    },
    clickAffirm(saveType, tips) {
      console.log(this.listPreviewStowage[0].carNumber);
      //确认配载
      this.$confirm(`确定要把所选任务进行${tips}吗? 请谨慎操作`)
        .then(() => {
          this.confirmcreateDispatchApi(saveType);
        })
        .catch(() => {});
    },
    //确认卸载
    confirmcreateDispatchApi(saveType) {
      let dispatchInfoReqs = [];
      let arrs = _.cloneDeep(this.listPreviewStowage);
      if (!arrs.every((n) => n.isHasClash == 0)) {
        this.$message.warning(`含有冲突品类商品！`);
        return false;
      }
      for (let i = 0; i < arrs.length; i++) {
        let element = arrs[i];
        if (!element.carCategoryConfDictId) {
          this.$message.warning(
            `发车批次号：${element.dispatchNumber} 请选择车辆分类`
          );
          return false;
        }
        if (element.isTractor != 0 && element.isTractor != 1) {
          this.$message.warning(
            `发车批次号：${element.dispatchNumber} 请选择是否牵引车`
          );
          return false;
        }
        if (!element.carNumber) {
          this.$message.warning(
            `发车批次号：${element.dispatchNumber} 请选择车牌号码`
          );
          return false;
        }
        if (element.isTractor == 1 && !element.trailerNumber) {
          this.$message.warning(
            `发车批次号：${element.dispatchNumber} 请输入挂车号码`
          );
          return false;
        }
        if (!element.driverOneId) {
          this.$message.warning(
            `发车批次号：${element.dispatchNumber} 请选择司机一`
          );
          return false;
        }
        if (!element.dispatchContractNumber) {
          this.$message.warning(
            `发车批次号：${element.dispatchNumber} 请输入发车合同号`
          );
          return false;
        }
        if (!element.planDepartureTime) {
          this.$message.warning(
            `发车批次号：${element.dispatchNumber} 请选择预计发车日期`
          );
          return false;
        }
      }
      arrs.forEach((element) => {
        dispatchInfoReqs.push({
          taskInfoReqs:
            element.childs &&
            element.childs.length &&
            element.childs[0].children.map((n) => {
              return {
                sort: n.sort,
                taskId: n.taskId,
              };
            }),
          number: element.dispatchNumber,
          driverReq: {
            carCategoryConfDictId: element.carCategoryConfDictId,
            carNumber: element.carNumber,
            dispatchContractNumber: element.dispatchContractNumber,
            driverOneId: element.driverOneId,
            driverOneName: element.driverOneName,
            driverTwoId: element.driverTwoId,
            driverTwoName: element.driverTwoName,
            isTractor: element.isTractor,
            planDepartureTime: element.planDepartureTime,
            supercargoOneId: element.supercargoOneId,
            supercargoOneName: element.supercargoOneName,
            supercargoTwoId: element.supercargoTwoId,
            supercargoTwoName: element.supercargoTwoName,
            trailerNumber: element.trailerNumber,
            remarks: element.remarks,
          },
        });
      });
      this.$API
        .createDispatch({
          saveType,
          dispatchInfoReqs,
        })
        .then((res) => {
          this.$message.success(res.data.message || "操作成功");
          this.$router.push({
            path: "/DispatchCar/VehicleStowage",
          });
        });
    },
    // 校验任务是否包含冲突品类
    async checkTaskHasClashItemApi() {
      let arrs = [];
      let lists = _.cloneDeep(this.selectList);
      lists.forEach(async (element) => {
        await this.$API
          .checkTaskHasClashItem({
            taskIds: element.childs.map((n) => {
              return n.taskId;
            }),
          })
          .then((res) => {
            this.$message.success(res.data.message || "操作成功");
            let item = element;
            item.carCategoryConfDictId = "";
            item.carNumber = "";
            item.dispatchContractNumber = "";
            item.driverOneId = "";
            item.driverOneName = "";
            item.driverTwoId = "";
            item.driverTwoName = "";
            item.isTractor = 1;
            item.planDepartureTime = "";
            item.supercargoOneId = "";
            item.supercargoOneName = "";
            item.supercargoTwoId = "";
            item.supercargoTwoName = "";
            item.trailerNumber = "";
            item.remarks = "";
            item.isHasClash = res.data.result.isHasClash;
            item.isHase = false;
            item.carNumberList1 = [];
            item.carNumberList2 = [];
            let setchild = element.childs;
            setchild.forEach((ec, ic) => {
              ec.indexset = ic + 1;
            });
            item.childs = [
              {
                indexset: "合计",
                packageCout: this.getreduce(setchild, "packageCout", 0),
                grossWeight: this.getreduce(setchild, "grossWeight"),
                netWeight: this.getreduce(setchild, "netWeight"),
                billingWeight: this.getreduce(setchild, "billingWeight"),
                volume: this.getreduce(setchild, "volume"),
                children: setchild,
              },
            ];
            arrs.push(item);
          });
      });
      this.listPreviewStowage = arrs;
    },
    getreduce(arr, str, number = 3) {
      return arr.reduce((pre, cur) => {
        return this.$TOOLS.mathToFixed(this.$TOOLS.add(pre, cur[str]), number);
      }, 0);
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.infoDiv {
  border: 1px solid @borderColor;
  border-radius: 4px;
  padding: 16px;
  margin-top: 16px;

  .h3title {
    padding: 10px 16px;
  }

  .formbox {
    padding: 0 16px;
  }

  .textArea {
    height: 100%;
  }

  .dialogTims {
    /deep/ .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 150px !important;
    }
  }

  .glo_Table {
    padding: 10px 16px;
  }

  .tipsclass {
    margin-left: 12px;
    color: red;
    font-size: 14px;
  }
}
</style>
